(()=>{
  if(window.__shEditableCartQty)return;
  window.__shEditableCartQty=true;
  let busy=false;
  const limits=el=>({
    min:Math.max(1,parseInt(el.dataset.shMin,10)||1),
    step:Math.max(1,parseInt(el.dataset.shStep,10)||1)
  });
  const enhance=()=>{
    document.querySelectorAll('.sh-cart-qty').forEach(box=>{
      if(box.querySelector('[data-sh-cart-qty-input]'))return;
      const display=box.querySelector('span');
      const dec=box.querySelector('[data-sh-cart-action="decrease"]');
      if(!display||!dec)return;
      const rule=limits(box);
      const input=document.createElement('input');
      input.type='number';
      input.min=String(rule.min);
      input.step=String(rule.step);
      input.inputMode='numeric';
      input.pattern='[0-9]*';
      input.value=display.textContent.trim()||String(rule.min);
      input.className='sh-cart-qty__input';
      input.dataset.shCartQtyInput='';
      input.dataset.key=dec.dataset.key||'';
      input.setAttribute('aria-label','Quantity');
      display.replaceWith(input);
    });
  };
  const commit=async input=>{
    if(busy)return;
    const rule=limits(input.closest('.sh-cart-qty'));
    let quantity=parseInt(input.value,10);
    if(!Number.isSafeInteger(quantity))quantity=rule.min;
    quantity=Math.max(rule.min,Math.ceil(quantity/rule.step)*rule.step);
    input.value=String(quantity);
    const key=input.dataset.key;
    if(!key)return;
    if(!window.StickerheadsCart||typeof window.StickerheadsCart.change!=='function'){
      console.warn('Stickerheads cart is not ready');
      return;
    }
    busy=true;
    input.disabled=true;
    try{
      await window.StickerheadsCart.change(key,quantity);
    }catch(error){
      console.error('Stickerheads cart quantity update:',error);
      if(typeof window.StickerheadsCart.refresh==='function'){
        await window.StickerheadsCart.refresh().catch(()=>{});
      }
    }finally{
      busy=false;
      if(input.isConnected)input.disabled=false;
    }
  };
  document.addEventListener('change',event=>{
    const input=event.target.closest&&event.target.closest('[data-sh-cart-qty-input]');
    if(input)commit(input);
  });
  document.addEventListener('keydown',event=>{
    const input=event.target.closest&&event.target.closest('[data-sh-cart-qty-input]');
    if(!input)return;
    if(event.key==='Enter'){event.preventDefault();input.blur();}
    if(['-','e','E','+','.'].includes(event.key))event.preventDefault();
  });
  const observer=new MutationObserver(enhance);
  const start=()=>{
    enhance();
    observer.observe(document.body,{childList:true,subtree:true});
  };
  if(document.readyState==='loading')document.addEventListener('DOMContentLoaded',start,{once:true});
  else start();
})();